// Full-document render of the tempurpedic OrderIssuePage FORM state:
// PageSkeleton (the React document shell, normal site chrome) wrapping
// OrderIssuePageBody.
import React from "react";

import { templates } from "@reactivated";

import { OrderIssuePageBody } from "../components/OrderIssuePageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton). The body accepts Immutable props, to which these are
// assignable.
type IProps = templates.OrderIssuePageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* {% block extra_meta %}: React 19 hoists this into <head>. */}
            <meta name="chatTags" content="contact" />
            <OrderIssuePageBody {...props} />
        </PageSkeleton>
    );
};
